import { createRoot } from 'react-dom/client'

if (import.meta.env.DEV) import('react-grab')

import { createSaaSApp } from '@xhubio-saas/core-frontend/kernel'
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import '@fontsource-variable/outfit'
import './index.css'
import { saasConfig } from './saas.config'

/**
 * Create and render the SaaS application
 *
 * The createSaaSApp function from frontend-kernel provides:
 * - Authentication (login, register, logout, 2FA)
 * - Internationalization with European languages
 * - Theme support (light/dark/system)
 * - Plugin system for extensibility
 * - tRPC client for type-safe API calls
 * - Protected routes with permission guards
 */
const App = createSaaSApp(saasConfig)

createRoot(document.getElementById('root')!).render(<App />)
